import { render, staticRenderFns } from "./LPFooter.vue?vue&type=template&id=b513b640&scoped=true"
import script from "./LPFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./LPFooter.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LPFooter.vue?vue&type=style&index=0&id=b513b640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b513b640",
  null
  
)

export default component.exports